import { render, staticRenderFns } from "./IconPaidHoliday.vue?vue&type=template&id=5a204ece&"
import script from "./IconPaidHoliday.vue?vue&type=script&lang=js&"
export * from "./IconPaidHoliday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports